/* eslint-disable no-debugger */
import { Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, signal, OnInit } from '@angular/core';
import { MyAccessionsService } from '@/app/services/my-accessions.service';
import { Accession, regulations } from '@/app/interfaces/accession';
import { CommonModule } from '@angular/common';
import { SpanishDatePipe } from '../../../../pipe/date.pipe';
import { CollapsibleComponent } from '@/app/shared/collapsible/collapsible.component';
import { BackButtonComponent } from '@/app/shared/back-button/back-button.component';
import { ApprovedActions } from '@/app/interfaces/accessionsList';
import { ConfirmationService } from 'primeng/api';
import { environment } from '@/environments/environment';
import { DesyAngularModule } from 'desy-angular';
import { ReviewStatesComponent } from '@/app/shared/review-states/review-states.component';
import { ConfirmDialog } from 'primeng/confirmdialog';
@Component({
  selector: 'app-my-accessions-detail',
  imports: [
    ConfirmDialog,
    CommonModule,
    SpanishDatePipe,
    CollapsibleComponent,
    BackButtonComponent,
    DesyAngularModule,
    ReviewStatesComponent,
  ],
  templateUrl: './my-accessions-detail.component.html',
  styleUrl: './my-accessions-detail.component.scss',
  providers: [MyAccessionsService, ConfirmationService],
})
export class MyAccessionsDetailComponent implements OnInit {
  constructor(
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private router: Router,
    @Inject(MyAccessionsService) private myAccessionsService: MyAccessionsService
  ) {}

  urlDetails = environment.urlDetail;
  accession = signal<Accession | null>(null);
  colorBox = signal('');
  stateTextFormat = signal('');
  stateServices = signal<{ text: string; state: string }[]>([]);
  rptsFormated? = null;
  list = null;
  id = null;
  buttonsOptions!: ApprovedActions;
  jobCode = JSON.parse(localStorage.getItem('userData')).roleCode;
  isDpd: boolean = false;
  isSend = signal(false);

  regulationData: regulations = {
    type: '',
    range: '',
    date: '',
    regulationsTitle: '',
    regulationsUrl: '',
    limitTime: '',
  };

  tabsItemsRpts = signal([
    { title: 'Rpts de mi equipo', id: '1' },
    { title: 'Rpts gobierno de Aragon', id: '2' },
  ]);
  stateGroup: { group: string; state: string }[] = [];

  navigateToEditRpts(id: string) {
    this.router.navigate(['/mis-adhesiones/detalles/editar-rpts', id]);
  }

  confirmUpdateAccession(accession, newValue) {
    this.confirmationService.confirm({
      message: 'Va a modificar el estado de adhesión. ¿Está seguro/a de que desea continuar?',
      header: 'Confirmación',
      closable: true,
      closeOnEscape: true,
      icon: 'pi pi-exclamation-triangle',
      rejectButtonProps: {
        label: 'Cancelar',
        severity: 'secondary',
        outlined: true,
      },
      acceptButtonProps: {
        label: 'Guardar',
      },
      accept: () => {
        this.handleActionAccesion(accession, newValue);
      },
    });
  }

  private mapStateToColor(state: string): string {
    switch (state?.toLowerCase()) {
      case 'rejected':
        return 'bg-red-500';
      case 'pending':
        return 'bg-info-base';
      case 'approved':
        return 'bg-success-base';
      case 'blocked':
        return 'bg-neutral-light';
      case 'finished':
        return 'bg-neutral-dark';
      default:
        return 'bg-neutral-dark'; // fallback
    }
  }
  private stateText(state): string {
    switch (state?.toLowerCase()) {
      case 'rejected':
        return 'RECHAZADA';
      case 'pending':
        return 'PENDIENTE';
      case 'approved':
        return 'APROBADA';
      case 'blocked':
        return 'BLOQUEADA';
      case 'finished':
        return 'FINALIZADA';
      default:
        return 'DESCONOCIDA';
    }
  }
  private responsible(serviceManagerStr, serviceDpdStr): { text: string; state: string }[] {
    let serviceManager = null;
    let serviceDpd = null;
    if (serviceManagerStr) {
      serviceManager = serviceManagerStr?.toLowerCase();
    }
    if (serviceDpdStr) {
      serviceDpd = serviceDpdStr?.toLowerCase();
    }
    switch (true) {
      case serviceManager && serviceDpd: {
        const managerStatus =
          serviceManager === 'pending'
            ? { text: 'Jefe de servicios', state: '⚠️ PENDIENTE' }
            : serviceManager === 'rejected'
              ? { text: 'Jefe de servicios', state: '❌ RECHAZADA' }
              : serviceManager === 'blocked'
                ? { text: 'Jefe de servicios', state: '🔒 BLOQUEADA/FINALIZADA' }
                : serviceManager
                  ? { text: 'Jefe de servicios', state: '✅ APROBADA' }
                  : { text: 'Jefe de servicios', state: '✖️' };

        const dpdStatus =
          serviceDpd === 'pending'
            ? { text: 'Responsable de protección de datos', state: '⚠️ PENDIENTE' }
            : serviceDpd === 'rejected'
              ? { text: 'Responsable de protección de datos', state: '❌ RECHAZADA' }
              : serviceDpd === 'blocked'
                ? { text: 'Responsable de protección de datos', state: '🔒 BLOQUEADA/FINALIZADA' }
                : serviceDpd
                  ? { text: 'Responsable de protección de datos', state: '✅ APROBADA' }
                  : { text: 'Responsable de protección de datos', state: '✖️' };

        return [managerStatus, dpdStatus];
      }
      case serviceManager && !serviceDpd: {
        const managerStatus =
          serviceManager === 'pending'
            ? { text: 'Jefe de servicios', state: '⚠️ PENDIENTE' }
            : serviceManager === 'rejected'
              ? { text: 'Jefe de servicios', state: '❌ RECHAZADA' }
              : serviceManager === 'blocked'
                ? { text: 'Jefe de servicios', state: '🔒 BLOQUEADA/FINALIZADA' }
                : serviceManager
                  ? { text: 'Jefe de servicios', state: '✅ APROBADA' }
                  : { text: 'Jefe de servicios', state: '✖️' };
        return [{ text: 'Jefe de servicios', state: managerStatus.state }];
      }
      default:
        return [];
    }
  }

  async handleActionAccesion(accesion, newValue) {
    if (accesion) {
      const params = {
        idAdhesion: accesion.id,
        state: newValue,
        modifiedDate: new Date(),
        deadline: null,
        userRole: null,
      };

      const loggedUserData = JSON.parse(localStorage.getItem('userData') || '{}');
      if (loggedUserData?.roles?.dpd) {
        params.userRole = 'DPD';
      } else if (loggedUserData?.roles?.jefe_servicio) {
        params.userRole = 'JS';
      }

      if (newValue === 'finished') {
        params.deadline = new Date().toISOString();
      } else {
        delete params.deadline;
      }
      const response = await this.myAccessionsService.updateAccesion(params);
      if (response) {
        await this.ngOnInit();
      }
    }
  }

  async loadAccesion() {
    const data = await this.myAccessionsService.getAccessionById(this.id, 'accession');
    return data;
  }

  buildAccessionActions(accession) {
    if (this.list === 'sent') {
      const options = [];
      const accessionState = accession?.state?.toLowerCase?.() ?? '';

      if (accessionState !== 'finished') {
        options.push({
          label: 'Modificar rpts',
          value: 'Modificar rpts',
          action: () => this.navigateToEditRpts(accession.id),
        });
      }

      if (accessionState === 'pending') {
        options.push({
          label: 'Finalizar',
          value: 'finished',
          action: () => this.confirmUpdateAccession(accession, 'finished'),
        });
      }

      if (options.length === 1) {
        accession.action = options[0].action;
      } else if (options.length > 1) {
        this.buttonsOptions = {
          label: 'Modificar adhesión',
          options: options,
        };
      }
    }
    if (this.list === 'received') {
      this.buttonsOptions = {
        label: 'Modificar adhesión',
        options: [],
      };
      switch (accession.state?.toLowerCase()) {
        case 'approved':
          this.buttonsOptions.options.push(
            {
              label: 'Finalizar',
              value: 'finished',
              action: () => this.confirmUpdateAccession(accession, 'finished'),
            },
            {
              label: 'Bloquear',
              value: 'blocked',
              action: () => this.confirmUpdateAccession(accession, 'blocked'),
            }
          );
          break;
        case 'pending':
          this.buttonsOptions.options.push(
            {
              label: 'Aprobar',
              value: 'approved',
              action: () => this.confirmUpdateAccession(accession, 'approved'),
            },
            {
              label: 'Rechazar',
              value: 'rejected',
              action: () => this.confirmUpdateAccession(accession, 'rejected'),
            }
          );
          break;
        case 'blocked':
          this.buttonsOptions.options.push(
            {
              label: 'Aprobar',
              value: 'approved',
              action: () => this.confirmUpdateAccession(accession, 'approved'),
            },
            {
              label: 'Finalizar',
              value: 'finished',
              action: () => this.confirmUpdateAccession(accession, 'finished'),
            }
          );
          break;

        case 'finished':
          this.buttonsOptions = undefined as unknown as ApprovedActions;
          break;
        default:
          break;
      }
    }
  }

  async ngOnInit() {
    this.id = Number(this.route.snapshot.paramMap.get('id'));

    this.list = this.route.snapshot.queryParamMap.get('list');
    if (!this.id || !this.list) {
      return;
    }
    const accession = await this.loadAccesion();
    this.regulationData = accession?.regulations ?? this.regulationData;
    if (accession) {
      const rpts = Array.isArray(accession.rpts) ? accession.rpts : [];
      this.rptsFormated = rpts.map((e) => {
        return {
          name: `${e.firstName} ${e.lastName}`,
          post: `${e.rpt} - ${e.position}`,
          mail: e.mail,
          agency: e.orgCode, // TODO este "agency" podría ser llamado orgCode en el front tambien para normalizar los datos. Viene como orgCode ya desde el back.
        };
      });
      const userData = JSON.parse(localStorage.getItem('userData') || 'null');
      const currentJobCode = userData?.jobCode ?? userData?.roleCode ?? null;
      this.isSend.set(accession.jobCodeCreationUser === currentJobCode);
    } else {
      return;
    }
    this.buildAccessionActions(accession);
    this.accession.set(accession);
    this.colorBox.set(this.mapStateToColor(this.accession()?.state));
    this.stateTextFormat.set(this.stateText(this.accession()?.state));
    this.stateGroup.push(
      { group: 'chief', state: this.accession()?.stateServiceManager ?? '' },
      { group: 'dpd', state: this.accession()?.stateDpd ?? '' }
    );
    this.isDpd = Boolean(this.accession()?.stateDpd);
  }
}
